import Vue from 'vue'
Vue.directive('number',{
    inserted:function (el,binding,vnode) {
        var input=el.getElementsByTagName('input')[0];
      input.style.textAlign='center';
        el.addEventListener('input',function (e) {
            var data=e.target.value,
                decimal=binding.value&&binding.value.precision?binding.value.precision:0,
                max=binding.value&&binding.value.max?binding.value.max:9999999999,
            min=binding.value&&binding.value.min?binding.value.min:-9999999999,
                step=binding.value&&binding.value.step?binding.value.step:1;
            if(decimal!=0) {
                data = data.replace(/[^\d.]/g,"");  //清除“数字”和“.”以外的字符
                data = data.replace(/\.{2,}/g, "."); //只保留第一个. 清除多余的
                data = data.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
                var test = '/^(\\-)*(\\d+)\\.{1}(\\d{0,' + decimal + '}).*$/';
                data = data.replace(eval(test), '$1$2.$3');//只能输入几个小数
            }else{
                data = data.replace(/[^\d]/g,"");//清除“数字”以外的字符
            }
            if(data.indexOf(".")< 0 && data !=""){//以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
                data= parseFloat(data);
            }
            if(data>max){
                var data1=String(data)
                data1=data1.substring(0,data1.length-1);
                data=Number(data1);
            }
            if(data<min&&data!=''){
                data=min;
            }
            console.log(data%step);
            if(Number(data%step)>(step/2)){
                data=Number(data) + Number(step - data%step)
            }else if(Number(data%step)<=(step/2)&&Number(data%step)>0){
                data=Number(data) - Number(data%step)
            }
            e.target.value = data;
            e.target.dispatchEvent(new Event("input"));
        })

    },
    componentUpdated:function (el,binding,vnode) {
        var input=el.getElementsByTagName('input')[0];
        input.addEventListener('blur',function (e) {
            var data=String(e.target.value);
            if(data.indexOf('.')==data.length-1&&data.indexOf('.')>0){
                console.log(data.indexOf('.'))
                e.target.value = Number(data);
            }
            if(data.indexOf('.')==0){
                console.log(data.indexOf('.'))
                e.target.value = Number('0'+data);
            }
        })
    }
})